export const version = "solidity/5.8.0";
//# sourceMappingURL=_version.js.map